module.exports = __webpack_public_path__ + "2ff663fe6411456c3abc7445331c696d.mp4";